import React from 'react'

interface AnalyticsIconProps {
  className?: string
  isActive?: boolean
}

export const AnalyticsIcon: React.FC<AnalyticsIconProps> = ({ 
  className = '', 
  isActive = false 
}) => {
  return (
    <svg 
      width="18" 
      height="21" 
      viewBox="0 0 18 21" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M13.0208 2.5095V18.2595C13.0208 20.013 14.2083 21 15.5104 21C16.6979 21 18 20.1705 18 18.2595V2.625C18 1.008 16.8125 0 15.5104 0C14.2083 0 13.0208 1.113 13.0208 2.5095ZM6.51042 10.5V18.2595C6.51042 20.0235 7.71875 21 9 21C10.1875 21 11.4896 20.1705 11.4896 18.2595V10.6155C11.4896 8.9985 10.3021 7.9905 9 7.9905C7.69792 7.9905 6.51042 9.1035 6.51042 10.5ZM2.48958 15.9915C3.86458 15.9915 4.97917 17.115 4.97917 18.4905C4.97917 19.8765 3.86458 21 2.48958 21C1.11458 21 0 19.8765 0 18.4905C0 17.115 1.11458 15.9915 2.48958 15.9915Z" 
        fill={isActive ? "#3B82F6" : "white"}
      />
    </svg>
  )
} 